import type { BrowseAutomationLogsParams } from './automations.api';

export type AutomationLogsFilter = BrowseAutomationLogsParams;

export const automationKeys = {
  all: ['creator-automations'] as const,
  list: (creatorId: number) => [...automationKeys.all, creatorId] as const,
  stats: (creatorId: number) =>
    [...automationKeys.all, creatorId, 'stats'] as const,
  logs: (creatorId: number, filter: AutomationLogsFilter) =>
    [...automationKeys.all, creatorId, 'logs', filter] as const,
  steps: (creatorId: number, automationType: string) =>
    [...automationKeys.all, creatorId, 'steps', automationType] as const,
} as const;
